// extracted by mini-css-extract-plugin
module.exports =  {"container":"article_item-module_container_e4538","link":"article_item-module_link_e66e8"};